import type {
  BoxDetailResponse,
  BoxListResponse,
  CreateBoxPayload,
  CreateBoxResponse,
  DeleteBoxResponse,
  RTUID,
  UpdateBoxParams,
  UpdateBoxPayload,
  UpdateBoxResponse,
} from '@/domains/asset-management/types/box';
import { APIS, URLS } from '@/shared/config/urls';
import { request } from '@/shared/utils/request';

// helper
const toUrlID = (id: string | number): string => String(id);

export const fetchBoxList = async (params: string = ''): Promise<BoxListResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.boxList(params)}`;
  return await request.get(url);
};

export const fetchDetailBox = async (rtuID: RTUID): Promise<BoxDetailResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.detailBox(toUrlID(rtuID))}`;
  return await request.get(url);
};

export const deleteBox = async (rtuID: RTUID): Promise<DeleteBoxResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.deleteBox(toUrlID(rtuID))}`;
  return await request.delete(url);
};

export const createBox = async (boxData: CreateBoxPayload): Promise<CreateBoxResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.createBox}`;
  return await request.post(url, boxData);
};

export const updateBox = async (
  boxData: UpdateBoxPayload,
  params: UpdateBoxParams
): Promise<UpdateBoxResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.updateBox(toUrlID(params.remote_terminal_unit_id))}`;
  return await request.put(url, boxData);
};
